import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-head box-shadow bg-white d-md-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }, null, -1)
const _hoisted_3 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", { class: "w-50" }, " # ", -1)
const _hoisted_7 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", null, " Decodeur ", -1)
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", null, " Abonné ", -1)
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", null, " Contact ", -1)
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", null, " Montant Payer ", -1)
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("th", null, " Montant Remise ", -1)
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "d-sm-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ValiderDemande = _resolveComponent("ValiderDemande")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _hoisted_6,
                _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.demandes[0]?.id), 1),
                _hoisted_8,
                _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.demandes[0]?.decodeur?.numAbonnement), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_10,
                _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.demandes[0]?.utilisateur?.nom), 1),
                _hoisted_12,
                _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.demandes[0]?.utilisateur?.telephone), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_14,
                _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.demandes[0]?.montantPayer) + " F CFA ", 1),
                _hoisted_16,
                _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.demandes[0]?.montantRemise) + " F CFA ", 1)
              ])
            ]),
            _hoisted_18,
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("a", {
                  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
                  href: "#",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#AddElementModal",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modification(_ctx.demandes[0])))
                }, " Valider la demande "),
                _createElementVNode("a", {
                  href: "javascript:void(0);",
                  class: "default-btn position-relative transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-danger fs-md-15 fs-lg-16 d-inline-block mt-10 mt-md-0 text-decoration-none",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.suppression(_ctx.demandes[0].id,_ctx.demandes,'demande','cette demande')))
                }, " Annuler la demande ")
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_ValiderDemande, {
      item: _ctx.selectedItem,
      onClose: _ctx.recharger
    }, null, 8, ["item", "onClose"])
  ], 64))
}